export var ConfigPrePostFixStrings;
(function (ConfigPrePostFixStrings) {
    ConfigPrePostFixStrings["TSCLI_CONFIG"] = "tscli.config";
    ConfigPrePostFixStrings["TITLE"] = "title";
    ConfigPrePostFixStrings["SUBTITLE"] = "subTitle";
    ConfigPrePostFixStrings["LABEL"] = "label";
    ConfigPrePostFixStrings["INFO_TOOLTIP"] = "infoTooltip";
})(ConfigPrePostFixStrings || (ConfigPrePostFixStrings = {}));
export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["SAVE_BUTTON"] = "tscli.ui.editScreen.saveBtn.title";
    TranslationsKeys["CANCEL_BUTTON"] = "tscli.ui.editScreen.cancelBtn.title";
    TranslationsKeys["RESET_BUTTON"] = "tscli.ui.editScreen.resetBtn.title";
    TranslationsKeys["BACK_BUTTON"] = "tscli.ui.editScreen.backBtn.title";
    TranslationsKeys["MODAL_TITLE"] = "tscli.ui.confirmationModal.title";
    TranslationsKeys["MODAL_CANCEL_BTN"] = "tscli.ui.confirmationModal.cancelBtn.label";
    TranslationsKeys["MODAL_CONFIRM_BTN"] = "tscli.ui.confirmationModal.confirmBtn.label";
    TranslationsKeys["MODAL_CONTENT"] = "tscli.ui.confirmationModal.content";
    TranslationsKeys["SUCCESS_MESSAGE"] = "tscli.ui.datasave.success.message";
    TranslationsKeys["APP_SETTINGS_SAVE_SUCCESS_MESSAGE"] = "tscli.ui.appsettings.datasave.success.message";
    TranslationsKeys["LLM_SUCCESS_MESSAGE"] = "tscli.ui.llmsave.success.message";
    TranslationsKeys["FAILURE_MESSAGE"] = "tscli.ui.datasave.failure.message";
    TranslationsKeys["SETTINGS_GET_FAILURE_MESSAGE"] = "tscli.ui.setting.get.failure.message";
    TranslationsKeys["DATASAVE_INFO_MESSAGE"] = "tscli.ui.datasave.info.message";
    TranslationsKeys["SAVECONFIRMATION_MODAL_TITLE"] = "tscli.ui.saveconfirmation.modal.title";
    TranslationsKeys["SAVECONFIRMATION_MODAL_CONFIRM_BTN"] = "tscli.ui.saveconfirmation.confirm.label";
    TranslationsKeys["SAVECONFIRMATION_MODAL_CANCEL_BTN"] = "tscli.ui.saveconfirmation.cancel.label";
    TranslationsKeys["SAVECONFIRMATION_MODAL_CONTENT"] = "tscli.ui.saveconfirmation.modal.message";
    TranslationsKeys["SAVECONFIRMATION_LOADING_MESSAGE"] = "tscli.ui.saveconfirmation.loading.message";
    TranslationsKeys["SETTINGS_INFO_MESSAGE"] = "tscli.ui.settingchange.info.message";
    TranslationsKeys["LEARN_MORE"] = "tscli.ui.learnmore.label";
    TranslationsKeys["CLICK_HERE"] = "CLICK_HERE";
    TranslationsKeys["ENABLED_LABEL"] = "tscli.ui.enabled.label";
    TranslationsKeys["DISABLED_LABEL"] = "tscli.ui.disabled.label";
    TranslationsKeys["YES_LABEL"] = "tscli.ui.yes.label";
    TranslationsKeys["NO_LABEL"] = "tscli.ui.no.label";
    TranslationsKeys["EARLY_ACCESS_EMPTY_SCREEN_BANNER_MESSAGE"] = "admin.earlyaccess.nodata";
    TranslationsKeys["DATA_MODEL_VALIDATE_BUTTON"] = "dataModelling.admin.page.validate.button";
    TranslationsKeys["DATA_MODEL_VALIDATE_BUTTON_TITLE"] = "dataModelling.admin.page.validate.title";
    TranslationsKeys["DATA_MODEL_VALIDATE_SUCCESS_MESSAGE"] = "dataModelling.admin.page.validate.success.message";
    TranslationsKeys["DATA_MODEL_VALIDATE_FAILURE_MESSAGE"] = "dataModelling.admin.page.validate.failure.message";
    TranslationsKeys["CANCEL_MODAL_TITLE"] = "tscli.ui.cancel.modal.title";
    TranslationsKeys["CANCEL_MODAL_CONFIRM_BTN"] = "tscli.ui.cancel.confirm.label";
    TranslationsKeys["CANCEL_MODAL_CANCEL_BTN"] = "tscli.ui.cancel.cancel.label";
    TranslationsKeys["CANCEL_MODAL_CONTENT"] = "tscli.ui.cancel.modal.message";
    TranslationsKeys["SPOTTER_LABEL"] = "tscli.ui.spotter.label";
    TranslationsKeys["ASK_SAGE_LABEL"] = "tscli.ui.askSage.label";
    TranslationsKeys["SPOTTER_AGENT_LABEL"] = "tscli.ui.spotterAgent.label";
    TranslationsKeys["SPOTTER_CLASSIC_LABEL"] = "tscli.ui.spotterClassic.label";
    TranslationsKeys["SAVECONFIRMATION_MODAL_CONTINUE_BTN"] = "tscli.ui.saveconfirmation.continue.label";
    TranslationsKeys["SPOTTER_SAVE_CONFIRMATION_MODAL_TITLE_SPOTTER3"] = "tscli.ui.spotterSaveconfirmation.modal.spotter3.title";
    TranslationsKeys["SPOTTER_SAVE_CONFIRMATION_MODAL_BODY_SPOTTER3"] = "tscli.ui.spotterSaveconfirmation.modal.body.spotter3";
    TranslationsKeys["SPOTTER_SAVE_CONFIRMATION_MODAL_BODY_LLM_GATEWAY"] = "orion.aiModelType.LLMGatewayv2.confirm.body";
    TranslationsKeys["SPOTTER_SAVE_CONFIRMATION_MODAL_WARN_INFO_LLM_GATEWAY"] = "orion.aiModelType.LLMGatewayv2.confirm.warnInfo";
    TranslationsKeys["SPOTTER_SAVE_CONFIRMATION_MODAL_TITLE_LLM_GATEWAY"] = "orion.aiModelType.LLMGatewayv2.confirm.title";
})(TranslationsKeys || (TranslationsKeys = {}));
export var DATA_MODELING_CONSTANTS;
(function (DATA_MODELING_CONSTANTS) {
    DATA_MODELING_CONSTANTS["DATA_MODEL_TAB"] = "dataModelling";
    DATA_MODELING_CONSTANTS["UPGRADING_DATA_MODEL_FLAG"] = "orion.upgradeToV2Worksheet";
})(DATA_MODELING_CONSTANTS || (DATA_MODELING_CONSTANTS = {}));
export const EA_FEATURE_TAB = 'early_access_feature';
export const ADMINISTRATION_TAB = 'administration';
export const RESTART_FLAGS = [];
export const SPOTTER_VERSION_SETTING = 'orion.spotterExperience';
export const CONTEXT = {
    ALL: { id: 'all-org', value: '-1', view_mode: 'all' },
    PRIMARY: { id: 'primary-org', value: '0', view_mode: 'primary' },
    NONE: { id: 'none-org', value: '', view_mode: '' },
};
export var SPOTTER_VERSIONS;
(function (SPOTTER_VERSIONS) {
    SPOTTER_VERSIONS["SPOTTER3"] = "SPOTTER3";
    SPOTTER_VERSIONS["SPOTTER_CLASSIC"] = "SPOTTER_CLASSIC";
    SPOTTER_VERSIONS["SPOTTER_AGENTIC"] = "SPOTTER_AGENTIC";
})(SPOTTER_VERSIONS || (SPOTTER_VERSIONS = {}));
//# sourceMappingURL=common.js.map